import { FC, useContext } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import Page from '../page/LinkPrefetchEditPage';

const LinkPrefetchEditPage: FC = () => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      organization={state.lastAccessedOrganization.item}
      speculationRule={state.speculationRule.data}
      speculationRuleLoading={state.speculationRule.fetching > 0}
      getSpeculationRule={dependency.javaScirptCodeUsecase.getSpeculationRules}
      putSpeculationRule={(speculationRule) => {
        dependency.javaScirptCodeUsecase.putSpeculationRule(speculationRule)
          .then(() => {
            dependency.messageDispatcher.notifyUnimportant('設定を保存しました', { severity: 'success' });
          })
          .catch((error) => {
            dependency.messageDispatcher.notifyUnimportant(error.message, { severity: 'error' });
          });
      }}
      onMount={() => {
        dependency.javaScirptCodeUsecase.getSpeculationRules();
      }}
    />
  );
};

export default LinkPrefetchEditPage;

